import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=72da74b3&"
import script from "./Option.vue?vue&type=script&lang=ts&"
export * from "./Option.vue?vue&type=script&lang=ts&"
import style0 from "./Option.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports